import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/common/cs_close.png'


const _hoisted_1 = { class: "title-text" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "container" }

import { ref } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'noticePopup',
  setup(__props, { expose: __expose }) {

const show = ref(false)
const openPopup = () => {
    show.value = true;
}

const closePopup = () => {
    show.value = false;
}

__expose({
    openPopup
})

return (_ctx: any,_cache: any) => {
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    onClickOverlay: closePopup,
    show: show.value,
    "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((show).value = $event)),
    position: "bottom",
    style: { height: '80%', zIndex:'10002' },
    class: "notice-popup"
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        class: "closeIcon",
        src: _imports_0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (closePopup()))
      }),
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('home.latestNews')), 1),
      _createElementVNode("div", {
        class: "notice-content",
        innerHTML: _ctx.$t('home.noticeContent')
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "button-style",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (closePopup()))
        }, _toDisplayString(_ctx.$t('home.IUnderstand')), 1)
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})